<div class="overlay-form" *ngIf="isFlag">
    <div class="chepfm--form__collapse-wrapper"
        [ngClass]="isFlag ? 'chepfm--form__collapse-show' : 'chepfm--form__collapse-hide'">
        <div class="chepfm--form__collapse-header">
            <h6 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.form-title'"></h6>
            <div class="close-icon">
                <button type="button" class="btn btn-link" (click)="onCloseClick()">
                    <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                </button>
            </div>
        </div>

        <div class="chepfm--form__collapse-contain">
            <form class="chepfm--form" [formGroup]="countryForm">
                <div class="row">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.country-name'"></label>
                            <input type="text" class="form-control" formControlName="countryName" appAlphabetOnly appCapitalizeFirst
                                [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.country-name'}]">
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.country-code'"></label>
                            <input type="text" class="form-control" formControlName="countryCode" appAlphabetOnly
                                maxlength="3" minlength="3"
                                [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.country-code'}]">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.time-zone'"></label>
                            <ng-select [items]="timeZoneList" [bindLabel]="'time_zone'" [hideSelected]="true"
                                formControlName="timeZone"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.voucher-charge'"></label>
                            <input type="text" class="form-control" formControlName="initialVoucherCharge" appNumericOnly  
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.voucher-charge'}]"
                            [(ngModel)]="initialVoucherCharge">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6" *ngIf="!isShowFrequencyContent">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.fixed-charges-frequency'"></label>
                            <ng-select [items]="fixedChargeFrequency" [bindLabel]="'charges'" [hideSelected]="true"
                                formControlName="fixedChargesFrequency" (change)="changeFixedChargesFrequency($event)"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="calendarStatus">
                        <label [i18n]="'df-management.form.model-popup.calendarStatus'"></label>
                        <div class="desc" (click)="editCalendar()">
                                <span>
                                    <i class="fa fa-check-circle fa-x" aria-hidden="true" [i18n]="'df-management.form.model-popup.calendarUploaded'"></i>
                                </span>&nbsp;
                                <img src="assets/eyeicon.svg" alt="">
                            
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="fixedCharge === 'Weekly'">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.start-day'"></label>
                            <ng-select [items]="days" [bindLabel]="'Value'" [hideSelected]="true"
                                formControlName="weeklyStartDay"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.end-day'"></label>
                            <ng-select [items]="days" [bindLabel]="'Value'" [hideSelected]="true"
                                formControlName="weeklyEndDay"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <h5 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.schedulers-title'"></h5>
                <hr />
                <div class="row">
                    <div class="col-xs-6">
                        <div class="chepfm-header">
                            <h4 class="chepfm--form__collapse-heading"
                                [i18n]="'df-management.df-admin.form.sequencial-run'"></h4>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="chepfm-header sequencial-style">
                            <app-switcher id="region-trailers-management" formControlName="sequencialType"
                                (change)="onChange($event.target.checked)">
                            </app-switcher><br>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="chepfm-header">
                            <img class="cma-image" src="/assets/charges-icons/information.png">
                            <span *ngIf="!isShowFrequencyContent" class="description-sequencial" [i18n]="'df-management.df-admin.form.sequencial-description'"></span>
                            <span  *ngIf="isShowFrequencyContent" class="description-sequencial" [i18n]="'df-management.df-admin.form.sequencial-description-usa'"></span>

                        </div>
                    </div>
                </div>
                <br>
                <div class="row" *ngIf="isShowInputBox">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.select-frequency'"></label>
                            <ng-select [items]="searchFrequency" [bindLabel]="'frequency'" [hideSelected]="true"
                                formControlName="selectSchedulersFrequency" (change)="changeSequencalFrequency($event)"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="sequencialSearchTime === 'once a day'">
                        <div class="data-filter">
                            <section class="card input-dropdown" *ngIf="isSequencial">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="sequencialdaysOftheWeek"
                                                    (change)="toggleCheckbox(item, 'sequencial')" />
                                                <span [ngStyle]="{'background': selectedCheckSequencialboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <h4 class="select-time-heading"
                                            [i18n]="'df-management.df-admin.form.select-time'"></h4>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="col-xs-12">
                                                    <div class="data-filter">
                                                        <input class="form-control" [dpDayPicker]="dayConfig" 
                                                            [theme]="'date-time-picker'" formControlName="sequencialdatepicker"
                                                            mode='time' [maxLength]="5"  (keypress)="numberWithAllowColon($event)"
                                                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.enter-time'}]">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit"  appDebounceClick (debounceClick)="takeAction('sequencial')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day-time'"></label>
                            <div class="input-icons" (click)="hideInput('sequencial')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="dateTimeSequencial"
                                [placeholder]="'df-management.df-admin.form.select-days-and-time' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="sequencialSearchTime === 'every six hours'">
                        <div class="data-filter">
                            <section class="card input-days-dropdown" *ngIf="isSequencial">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="sequencialdaysOftheWeek"
                                                    (change)="toggleCheckbox(item, 'sequencial')" />
                                                <span [ngStyle]="{'background': selectedCheckSequencialboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <div class="row select-day-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit" appDebounceClick (debounceClick)="takeAction('sequencial')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day'"></label>
                            <div class="input-icons" (click)="hideInput('sequencial')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="daySequencial"
                                [placeholder]="'df-management.df-admin.form.select-day' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="sequencialSearchTime === 'specific day of month'">
                        <label class="required" [i18n]="'df-management.df-admin.form.date-time'"></label>
                        <div class="input-icons">
                            <input class="form-control calender-icon" [dpDayPicker]="dateConfig" [theme]="'date-time-picker'"
                                formControlName="sequencialSpecialDaysOfMonth" mode='daytime' maxlength="16" (keypress)="numberWithAllowSpecialChar($event)"
                                [placeholder]="'df-management.df-admin.form.select-date-and-time' | translate">
                        </div>
                    </div>
                    
                    <div class="col-xs-6" *ngIf="sequencialSearchTime === 'last day of month'">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.time'"></label>
                            <input class="form-control" [dpDayPicker]="dayConfig" [theme]="'date-time-picker'" 
                            formControlName="sequencialLastDaysOfMonth" mode='time'[maxLength]="5" (keypress)="numberWithAllowColon($event)"
                                [placeholder]="'df-management.df-admin.form.enter-time' | translate">
                    </div>
                    </div> 
                </div>
                <div class="row" *ngIf="!isShowInputBox">
                    <div class="col-xs-6">
                        <h6 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.asset-search'"
                          *ngIf="isShowFrequency"></h6>
                        <h6 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.carrier-search'"
                          *ngIf="!isShowFrequency"></h6>
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.asset-search-frequency'" *ngIf="isShowFrequency"></label>
                            <label class="required" [i18n]="'df-management.df-admin.form.carrier-search-frequency'" *ngIf="!isShowFrequency"></label>
                            <ng-select [items]="searchFrequency" [bindLabel]="'frequency'" [hideSelected]="true"
                                formControlName="assetSearchFrequency" (change)="changeAssetFrequency($event)"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-xs-6 asset-input" *ngIf="assetSearchTime === 'once a day'">
                        <div class="data-filter">
                            <section class="card input-dropdown" *ngIf="isAssetSearch">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="assetdaysOftheWeek" 
                                                    (change)="toggleCheckbox(item, 'assetSearch')" />
                                                <span [ngStyle]="{'background': selectedCheckAssetboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <h4 class="select-time-heading"
                                            [i18n]="'df-management.df-admin.form.select-time'"> </h4>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="col-xs-12">
                                                    <div class="data-filter">
                                                        <input class="form-control" [dpDayPicker]="dayConfig"
                                                            [theme]="'date-time-picker'" formControlName="assetdatepicker"
                                                            mode='time'  maxlength="5" (keypress)="numberWithAllowColon($event)"
                                                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.enter-time'}]">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit"  appDebounceClick (debounceClick)="takeAction('assetSearch')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day-time'"></label>
                            <div class="input-icons" (click)="hideInput('assetSearch')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="dateTimeAsset"
                                [placeholder]="'df-management.df-admin.form.select-days-and-time' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6 asset-input" *ngIf="assetSearchTime === 'every six hours'">
                        <div class="data-filter">
                            <section class="card input-days-dropdown" *ngIf="isAssetSearch">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="assetdaysOftheWeek"
                                                    (change)="toggleCheckbox(item, 'assetSearch')" />
                                                <span [ngStyle]="{'background': selectedCheckAssetboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <div class="row select-day-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit" appDebounceClick (debounceClick)="takeAction('assetSearch')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day'"></label>
                            <div class="input-icons" (click)="hideInput('assetSearch')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="dayAsset"
                                [placeholder]="'df-management.df-admin.form.select-day' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6 asset-input" *ngIf="assetSearchTime === 'specific day of month'">
                        <label class="required" [i18n]="'df-management.df-admin.form.date-time'"></label>
                        <div class="input-icons">
                            <input class="form-control calender-icon" [dpDayPicker]="dateConfig" [theme]="'date-time-picker'"
                                formControlName="assetSpecialDaysOfMonth" mode='daytime' maxlength="16" (keypress)="numberWithAllowSpecialChar($event)"
                                [placeholder]="'df-management.df-admin.form.select-date-and-time' | translate">
                        </div>
                    </div>
                    <div class="col-xs-6 asset-input" *ngIf="assetSearchTime === 'last day of month'">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.time'"></label>
                            <input class="form-control" [dpDayPicker]="dayConfig" [theme]="'date-time-picker'"
                                formControlName="assetLastDaysOfMonth" mode='time'  maxlength="5" (keypress)="numberWithAllowColon($event)"
                                [placeholder]="'df-management.df-admin.form.enter-time' | translate">
                        </div>
                    </div>
                </div>
                <h6 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.load-search'"
                    *ngIf="!isShowInputBox"></h6>
                <div class="row" *ngIf="!isShowInputBox">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.load-search-frequency'"></label>
                            <ng-select [items]="searchFrequency" [bindLabel]="'frequency'" [hideSelected]="true"
                                formControlName="loadSearchFrequency" (change)="changeLoadFrequency($event)"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="loadSearchTime === 'once a day'">
                        <div class="data-filter">
                            <section class="card input-dropdown" *ngIf="isLoadSearch">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="loaddaysOftheWeek"
                                                    (change)="toggleCheckbox(item, 'loadSearch')" />
                                                <span [ngStyle]="{'background': selectedCheckloadboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <h4 class="select-time-heading"
                                            [i18n]="'df-management.df-admin.form.select-time'"></h4>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="col-xs-12">
                                                    <div class="data-filter">
                                                        <input class="form-control" [dpDayPicker]="dayConfig"
                                                            [theme]="'date-time-picker'" formControlName="loaddatepicker"
                                                            mode='time'  maxlength="5" (keypress)="numberWithAllowColon($event)"
                                                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.enter-time'}]">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit"  appDebounceClick (debounceClick)="takeAction('loadSearch')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day-time'"></label>
                            <div class="input-icons" (click)="hideInput('loadSearch')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="dateTimeLoad"
                                [placeholder]="'df-management.df-admin.form.select-days-and-time' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="loadSearchTime === 'every six hours'">
                        <div class="data-filter">
                            <section class="card input-days-dropdown" *ngIf="isLoadSearch">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="loaddaysOftheWeek"
                                                    (change)="toggleCheckbox(item, 'loadSearch')" />
                                                <span [ngStyle]="{'background': selectedCheckloadboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <div class="row select-day-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit" appDebounceClick (debounceClick)="takeAction('loadSearch')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day'"></label>
                            <div class="input-icons" (click)="hideInput('loadSearch')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="dayLoad"
                                [placeholder]="'df-management.df-admin.form.select-day' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="loadSearchTime === 'specific day of month'">
                        <label class="required" [i18n]="'df-management.df-admin.form.date-time'"></label>
                        <div class="input-icons">
                            <input class="form-control calender-icon" [dpDayPicker]="dateConfig" [theme]="'date-time-picker'"
                                formControlName="loadSpecialDaysOfMonth" mode='daytime' maxlength="16" (keypress)="numberWithAllowSpecialChar($event)"
                                [placeholder]="'df-management.df-admin.form.select-date-and-time' | translate">
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="loadSearchTime === 'last day of month'">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.time'"></label>
                            <input class="form-control" [dpDayPicker]="dayConfig" [theme]="'date-time-picker'"
                                formControlName="loadLastDaysOfMonth" mode='time' maxlength="5" (keypress)="numberWithAllowColon($event)"
                                [placeholder]="'df-management.df-admin.form.enter-time' | translate">
                        </div>
                    </div>
                </div>
                <h6 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.auto-calculate'"
                    *ngIf="isShowFrequency"></h6>
                <div class="row" *ngIf="isShowFrequency">
                    <div class="col-xs-6">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.auto-calculate-frequency'"></label>
                            <ng-select [items]="searchFrequency" [bindLabel]="'frequency'" [hideSelected]="true"
                                formControlName="autoCalculateFrequency" (change)="changeAutoFrequency($event)"
                                [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="autoCalculateSearchTime === 'once a day'">
                        <div class="data-filter">
                            <section class="card input-dropdown" *ngIf="isAutoCalculateSearch">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="autoCalculatedaysOftheWeek"
                                                    (change)="toggleCheckbox(item, 'autoCalculateSearch')" />
                                                <span [ngStyle]="{'background': selectedCheckAutoCalboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <h4 class="select-time-heading"
                                            [i18n]="'df-management.df-admin.form.select-time'"> </h4>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="col-xs-12">
                                                    <div class="data-filter">
                                                        <input class="form-control" [dpDayPicker]="dayConfig"
                                                            [theme]="'date-time-picker'" formControlName="autoCalculatedatepicker"
                                                            mode='time'  maxlength="5" (keypress)="numberWithAllowColon($event)"
                                                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.enter-time'}]">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row select-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit"  appDebounceClick (debounceClick)="takeAction('autoCalculateSearch')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day-time'"></label>
                            <div class="input-icons" (click)="hideInput('autoCalculateSearch')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="dateTimeAutoCalculate"
                                [placeholder]="'df-management.df-admin.form.select-days-and-time' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="autoCalculateSearchTime === 'every six hours'">
                        <div class="data-filter">
                            <section class="card input-days-dropdown" *ngIf="isAutoCalculateSearch">
                                <div class="card-body">
                                    <form [formGroup]="myForm">
                                        <h4 class="select-day-heading"
                                            [i18n]="'df-management.df-admin.form.select-day'">
                                        </h4>
                                        <div class="row select-day">
                                            <label class="weekDays-selector" *ngFor="let item of days">
                                                <input type="checkbox" id="weekday-{{item.Name}}" class="weekday"
                                                    formControlName="autoCalculatedaysOftheWeek"
                                                    (change)="toggleCheckbox(item, 'autoCalculateSearch')" />
                                                <span [ngStyle]="{'background': selectedCheckAutoCalboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                            </label>
                                        </div>
                                        <div class="row select-day-time">
                                            <div class="row">
                                                <div class="chepfm--form__buttonactions">
                                                    <button class="btn btn-i btn-primary" type="submit" appDebounceClick (debounceClick)="takeAction('autoCalculateSearch')">
                                                        <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            <label class="required" [i18n]="'df-management.df-admin.form.day'"></label>
                            <div class="input-icons" (click)="hideInput('autoCalculateSearch')" >
                                <img class="icon" src="/assets/charges-icons/clock.png">
                                <input class=" input-field  form-control input-color" formControlName="dayAutoCalculate"
                                [placeholder]="'df-management.df-admin.form.select-day' | translate" disabled >
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="autoCalculateSearchTime === 'specific day of month'">
                        <label class="required" [i18n]="'df-management.df-admin.form.date-time'"></label>
                        <div class="input-icons">
                            <input class="form-control calender-icon" [dpDayPicker]="dateConfig" [theme]="'date-time-picker'"
                                formControlName="autoCalculateSpecialDaysOfMonth" mode='daytime' maxlength="16" (keypress)="numberWithAllowSpecialChar($event)"
                                [placeholder]="'df-management.df-admin.form.select-date-and-time' | translate">
                        </div>
                    </div>
                    <div class="col-xs-6" *ngIf="autoCalculateSearchTime === 'last day of month'">
                        <div class="data-filter">
                            <label class="required" [i18n]="'df-management.df-admin.form.time'"></label>
                            <input class="form-control" [dpDayPicker]="dayConfig" [theme]="'date-time-picker'"
                                formControlName="autoCalculateLastDaysOfMonth" mode='time'  maxlength="5" (keypress)="numberWithAllowColon($event)"
                                [placeholder]="'df-management.df-admin.form.enter-time' | translate">
                        </div>
                    </div>
                </div>
                <br>
                <hr />
                <div class="voucher-box" *ngIf="fixedCharge && fixedCharge !== 'Custom'">
                    <div class="voucher-widge">
                        <h6 class="chepfm--form__collapse-heading"
                            [i18n]="'df-management.df-admin.form.voucher-update-job'"></h6>
                    </div>
                    <div class="cardWidget-content">
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="data-filter">
                                    <label class="required" [i18n]="'df-management.df-admin.form.voucher-frequency'"></label>
                                    <ng-select [items]="searchFrequency" [bindLabel]="'frequency'" [hideSelected]="true"
                                        formControlName="voucherJobFrequency" (change)="changeVoucherFrequency($event)"
                                        [placeholder]="'df-management.df-admin.form.select-placeholder' | translate">
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-xs-6" *ngIf="voucherJobSearchTime === 'once a day'">
                                <div class="data-filter">
                                    <section class="card input-dropdown" *ngIf="isVoucherSearch">
                                        <div class="card-body">
                                            <form [formGroup]="myForm">
                                                <h4 class="select-day-heading"
                                                    [i18n]="'df-management.df-admin.form.select-day'">
                                                </h4>
                                                <div class="row select-day">
                                                    <label class="weekDays-selector" *ngFor="let item of days">
                                                        <input type="checkbox" id="weekday-{{item.Name}}"
                                                            class="weekday" formControlName="voucherdaysOftheWeek"
                                                            (change)="toggleCheckbox(item, 'voucherSearch')" />
                                                        <span [ngStyle]="{'background': selectedCheckVoucherboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                                    </label>
                                                </div>
                                                <h4 class="select-time-heading"
                                                    [i18n]="'df-management.df-admin.form.select-time'"></h4>
                                                <div class="row select-time">
                                                    <div class="row">
                                                        <div class="col-xs-12">
                                                            <div class="data-filter">
                                                                <input class="form-control" [dpDayPicker]="dayConfig"
                                                                    [theme]="'date-time-picker'"  
                                                                    formControlName="voucherdatepicker" mode='time' maxlength="5" (keypress)="numberWithAllowColon($event)"
                                                                    [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.form.enter-time'}]">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row select-time">
                                                    <div class="row">
                                                        <div class="chepfm--form__buttonactions">
                                                            <button class="btn btn-i btn-primary" type="submit"  appDebounceClick (debounceClick)="takeAction('voucherSearch')">
                                                                <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </section>
                                    <label class="required" [i18n]="'df-management.df-admin.form.day-time'"></label>
                                    <div class="input-icons" (click)="hideInput('voucherSearch')" >
                                        <img class="icon" src="/assets/charges-icons/clock.png" />
                                        <input class=" input-field  form-control input-color" formControlName="dateTimeVoucher"
                                        [placeholder]="'df-management.df-admin.form.select-days-and-time' | translate" disabled >
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6" *ngIf="voucherJobSearchTime === 'every six hours'">
                                <div class="data-filter">
                                    <section class="card input-days-dropdown" *ngIf="isVoucherSearch">
                                        <div class="card-body">
                                            <form [formGroup]="myForm">
                                                <h4 class="select-day-heading"
                                                    [i18n]="'df-management.df-admin.form.select-day'">
                                                </h4>
                                                <div class="row select-day">
                                                    <label class="weekDays-selector" *ngFor="let item of days">
                                                        <input type="checkbox" id="weekday-{{item.Name}}"
                                                            class="weekday" formControlName="voucherdaysOftheWeek"
                                                            (change)="toggleCheckbox(item, 'voucherSearch')" />
                                                        <span [ngStyle]="{'background': selectedCheckVoucherboxes.has(item) ? '#0078bf' : 'white'}">{{item.Name}}</span>
                                                    </label>
                                                </div>
                                                <div class="row select-day-time">
                                                    <div class="row">
                                                        <div class="chepfm--form__buttonactions">
                                                            <button class="btn btn-i btn-primary" type="submit" appDebounceClick (debounceClick)="takeAction('voucherSearch')">
                                                                <span [i18n]="'df-management.df-admin.form.save-button'"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </section>
                                    <label class="required" [i18n]="'df-management.df-admin.form.day'"></label>
                                    <div class="input-icons" (click)="hideInput('voucherSearch')" >
                                        <img class="icon" src="/assets/charges-icons/clock.png">
                                        <input class=" input-field  form-control input-color" formControlName="dayVoucher"
                                        [placeholder]="'df-management.df-admin.form.select-day' | translate" disabled >
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6" *ngIf="voucherJobSearchTime === 'specific day of month'">
                                <label class="required" [i18n]="'df-management.df-admin.form.date-time'"></label>
                                <div class="input-icons">
                                    <input class="form-control calender-icon" [dpDayPicker]="dateConfig" [theme]="'date-time-picker'"
                                        formControlName="voucherSpecialDaysOfMonth" mode='daytime' maxlength="16" (keypress)="numberWithAllowSpecialChar($event)"
                                        [placeholder]="'df-management.df-admin.form.select-date-and-time' | translate">
                                </div>
                            </div>
                            <div class="col-xs-6" *ngIf="voucherJobSearchTime === 'last day of month'">
                                <div class="data-filter">
                                    <label class="required" [i18n]="'df-management.df-admin.form.time'"></label>
                                    <input class="form-control" [dpDayPicker]="dayConfig" [theme]="'date-time-picker'"
                                        formControlName="voucherLastDaysOfMonth" mode='time'  maxlength="5" (keypress)="numberWithAllowColon($event)"
                                        [placeholder]="'df-management.df-admin.form.enter-time' | translate">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                &nbsp;&nbsp;
                <br />
                <div class="chepfm--form__actions">
                    <i class="fa fa-ban repeat--icon" aria-hidden="true"></i>&nbsp;&nbsp;
                    <a class="chepfm--link" (click)="resetCountryData()">
                        <span [i18n]="'df-management.df-admin.form.reset-button'"></span>
                    </a>&nbsp;&nbsp;
                    <button class="btn btn-i btn-primary" type="submit" [disabled]="!countryForm.valid" appDebounceClick (debounceClick)="submit()">
                        <span [i18n]="'df-management.df-admin.form.submit-button'"></span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="overlay" *ngIf="isPopupModel">
    <div class="sucesspopup">
        <i class="fa fa-check-circle success-button"></i>
        <h4 [i18n]="'df-management.form.model-popup.heading'"></h4>
        <div class="content">
            <span [i18n]="'df-management.df-admin.popupModal.country-content'"></span>
        </div>
        <div class="form-group">
            <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="confirmData()">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>

<div id="customFrequencyModal" class="modal" [ngClass]="{'show': isModalOpen}">
    <div class="modal-content">
      <img class="crossIcon" src="/assets/crossIcon.svg" (click)="closeModal()">
      <span class="yearTitle" [i18n]="'df-management.form.model-popup.selectYear'"></span>
      <div>
        
        <div class="data-filter yearSelection">
            <label class="startYear" [i18n]="'df-management.form.model-popup.startYear'"></label>
            <ng-select [(ngModel)]="selectedYear">
                <ng-option *ngFor="let year of years" [value]="year">{{ year }}</ng-option>
              </ng-select>
        </div>
      </div>
      <div class="form-group">
        <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="calendarDatesNavigation()"
        [i18n]="'df-management.df-admin.form.submit-button'">
        </button>
    </div>
    </div>
  </div>